export const DEVELOPMENT = process.env.NODE_ENV === 'development';

export const ENVIRONMENT = DEVELOPMENT
  ? 'development'
  : window && window.location && window.location.hostname === 'homolog.nexatlas.com'
  ? 'homolog'
  : 'production';
